import color from 'markdown-it-color';

export default color;
